"use strict";
(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[9783],{

/***/ 89783:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

__webpack_require__.r(__webpack_exports__);
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "default": function() { return /* binding */ Redirect; }
/* harmony export */ });
/* harmony import */ var _helpers_misc_isServerSide__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(90257);
/* harmony import */ var _hooks_useEffect__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(10338);
/* harmony import */ var next_router__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(11163);
/* harmony import */ var next_router__WEBPACK_IMPORTED_MODULE_1___default = /*#__PURE__*/__webpack_require__.n(next_router__WEBPACK_IMPORTED_MODULE_1__);



function Redirect(props) {
    var url = props.url;
    var router = (0,next_router__WEBPACK_IMPORTED_MODULE_1__.useRouter)();
    (0,_hooks_useEffect__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)(function() {
        if (url.startsWith("/")) {
            router.replace(url);
        } else {
            if ((0,_helpers_misc_isServerSide__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z)()) return function() {};
            window.location.href = url;
        }
    }, []);
    return null;
};


/***/ })

}]);